<template>
  <v-container fluid class="d-flex pa-0 fullHeight py-10">
    <v-container fluid class="scrollableContent pa-0">
      <v-container class="container-custom px-6">
        <Breadcrumbs
          :title="$t('modules.admission.exceptions.table.breadcrumbs.title')"
          :description="$t('modules.admission.exceptions.table.breadcrumbs.description')"
        ></Breadcrumbs>
        <v-row justify="center">
          <v-col sm="12" class="viewSpaces">
            <SuperTable
              :headers="headers"
              :data="users"
              @search-action="searchAction"
              @action="confirmationPopUp"
            ></SuperTable>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <ActionPopUp
      :visible.sync="popupVisible"
      :selectedItem="selectedItem"
      :title="$t('modules.admission.exceptions.popup.title')"
      :studentCareer="studentCareer"
      @refresh="refreshUserData"
      @close="popupVisible = false"
      ></ActionPopUp>
  </v-container>
</template>

<script>
import SuperTable from '../Components/SuperTable/SuperTable';
import ActionPopUp from '../Components/ActionPopUp/ActionPopUp';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import { $students } from '../Services';

export default {
  name: 'ExceptionsView',
  components: {
    SuperTable,
    ActionPopUp,
    Breadcrumbs,
  },
  data() {
    return {
      student: {
        name: null,
        record: null,
      },
      search: '',
      users: [],
      userId: null,
      studentCareer: null,
      popupVisible: false,
      selectedItem: {},
      headers: [
        {
          text: this.$t('modules.exceptions.table.headers.identification'),
          value: 'identification',
          sortable: false
        },{
          text: this.$t('modules.exceptions.table.headers.name'),
          value: 'name'
        },{
          text: this.$t('modules.exceptions.table.headers.lastname'),
          value: 'lastname',
        },{
          text: this.$t('modules.exceptions.table.headers.career'),
          value: 'career',
          sortable: false
        },{
          text: this.$t('modules.exceptions.table.headers.user'),
          value: 'userAra',
          sortable: false
        },{
          text: this.$t('modules.exceptions.table.headers.career_status'),
          value: 'careerStatus.meaning',
          sortable: false
        },{
          text: this.$t('modules.exceptions.table.headers.term'),
          value: 'term',
          sortable: false,
          align:'center',
        },{
          text: '',
          value: 'action',
          sortable: false
        }
      ],
    }
  },
  methods: {
    searchAction(data) {
      this.search = data;
      this.getStudent();
    },
    refreshUserData() {
      this.getStudent();
      this.popupVisible = false;
    },
    async getStudent() {
      try {
        const student = await $students.find('studentCareersByIdentification', null, {
          params: { identification: this.search, isException: true },
        });
        this.users = [];
        if (student.data.studentCareers.length) {
          student.data.studentCareers.forEach(career => {
            this.studentCareer = career.studentCareer
            this.users.push({
              id: career.studentCareer,
              name: student.data.name,
              lastname: student.data.lastname,
              identification: student.data.identification,
              career: career.careerName,
              userAra: career.userAra != null ? career.userAra : '-',
              careerStatus: career.careerStatus,
              term: career.termValidCode,
              termId: career.termValidId,
              exception: career.exception,
              oldModality: career.oldModality,
              allowReenrollment: career.allowReenrollment,
              studentId: student.data.studentId,
              action: true,
            })
          })
        }
      } catch (error) {
        this.users = [];
      }
    },
    confirmationPopUp(item) {
      item.action ? this.popupVisible = true: this.popupVisible = false;
    },
  },
}
</script>
